import React from "react"

import Icon from "icons"
import LoginPasswordless from "components/login-passwordless"
import { Modal, Content, TopRow } from "./styles"

const AuthenticateModal = ({ customRedirectTo, onClose, onSuccess }) => (
  <Modal onClose={onClose}>
    <Content>
      <TopRow>
        <button type="button" onClick={onClose} aria-label="close-icon-button">
          <Icon id="close-icon" width={15} height={15} title="Close" />
        </button>
      </TopRow>
      <LoginPasswordless
        from="modal"
        onSuccess={onSuccess}
        onClose={onClose}
        customRedirectTo={customRedirectTo}
      />
    </Content>
  </Modal>
)

export default AuthenticateModal
